'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidMap = function IoAndroidMap(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.1 5c0.5 0 0.9 0.4 0.9 0.9v25.1c0 0.4-0.2 0.7-0.5 0.8l-9.5 3.2-10-3.5s-8.2 3.2-8.4 3.3-0.6 0.2-0.7 0.2c-0.5 0-0.9-0.4-0.9-0.9v-25.1c0-0.4 0.2-0.7 0.5-0.8l9.5-3.2 10 3.5s8-3.1 8.4-3.3 0.6-0.2 0.7-0.2z m-9.1 26.6v-19.8l-10-3.4v19.8z' })
        )
    );
};

exports.default = IoAndroidMap;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-map.js
// module id = 2358
// module chunks = 168707334958949